// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
// Optionnel : si vous souhaitez utiliser Analytics
// import { getAnalytics } from 'firebase/analytics';

import { getFunctions } from "firebase/functions";

// Informations de configuration depuis votre console Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAUnBI3ckK4uClMmlVQ4BlOqEwL35o5aHQ",
  authDomain: "normexport-9202d.firebaseapp.com",
  projectId: "normexport-9202d",
  storageBucket: "normexport-9202d.firebasestorage.app", // Vérifiez si c'est bien votre bucket (souvent se termine par ".appspot.com")
  messagingSenderId: "309489839454",
  appId: "1:309489839454:web:3ac6d3ddd3be0526e073cf",
  measurementId: "G-5GKBV0ZQRL"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Initialisation des services Firebase
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export const functions = getFunctions();

// Optionnel : initialisation d'Analytics si besoin
// const analytics = getAnalytics(app);

// Export des instances pour utilisation dans votre projet
export { db, auth, storage };
